import styled from 'styled-components';
import { device, radius, size } from '@/styles/template';

export const WrapAdvFlocktory = styled.a`
  margin: 0 auto;
  max-width: 320px;
  display: block;
  border-radius: ${radius.large};
  overflow: hidden;

  @media ${device.tablet} {
    margin: 0;
  }
`;

export const AdResultWrap = styled.div`

`

export const AdResultMobile = styled.div`
	min-height: 250px;
	//max-height: 320px;

	@media (min-width: 481px) {
	  display: none;
	}
`;

export const AdResultPC = styled.div`
  	overflow: hidden;
  	min-height: 90px;

	@media (max-width: 480px) {
	  display: none;
	}
`;